<div class="card my-3">
  <div class="d-flex align-items-center m-3">
    <div *ngIf="src || nick">
      <app-avatar [imageUrl]="src" [nick]="nick" size="lg" title="img"></app-avatar>
    </div>
    <div class="ml-2">
      <span class="title-font m-0">{{ heading }}</span>
      <p class="table-body-font mt-1" style="line-height: initial !important;" *ngIf="subHeading">
        {{ subHeading }}
      </p>
    </div>
  </div>
</div>
